import { render, staticRenderFns } from "./Rows.vue?vue&type=template&id=67618413&scoped=true&"
import script from "./Rows.vue?vue&type=script&lang=js&"
export * from "./Rows.vue?vue&type=script&lang=js&"
import style0 from "./Rows.vue?vue&type=style&index=0&id=67618413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67618413",
  null
  
)

export default component.exports